<template>
  <div class="alert" :class="'alert-' + type" v-if="message">{{ message }}</div>
</template>

<script setup>
  const props = defineProps({
    type: {
      type: String,
      default: 'danger'
    },
    message: String
  });
</script>
